import { useContext } from 'react';

import { WorkflowCreditAvailabilityContext } from '../contexts/WorkflowCreditAvailabilityContext/WorkflowCreditAvailabilityContext';

const skippedCreditAvailability = {
  blocked: false,
  refresh: async (): Promise<void> => {},
};

export const useWorkflowCreditAvailability = ({
  skip = false,
}: { skip?: boolean } = {}): {
  blocked: boolean;
  refresh: () => Promise<void>;
} => {
  const credit = useContext(WorkflowCreditAvailabilityContext);
  if (!credit) {
    throw new Error(
      'useWorkflowCreditAvailability must be used within a WorkflowCreditAvailabilityProvider',
    );
  }
  return skip ? skippedCreditAvailability : credit;
};
